import { Button, Stack, Text } from '@chakra-ui/react'

import ModalV3 from '@/components/UI/Modal/ModalV3'

import { ContactInfoAlert } from './ContactInfoAlert'
import { REVIEW_BUSINESS_DAYS } from './constants'

export function SignatureModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}): JSX.Element {
  return (
    <ModalV3
      title="Signature on a Form"
      size="2xl"
      open={isOpen}
      onClose={onClose}
      body={() => (
        <Stack spacing="16px">
          <Text>
            If you need a signature on a volunteer hours form, please email your completed form and
            a link to your Schoolhouse profile to <b>volunteering@schoolhouse.world</b>. To avoid
            delays, please pre-fill the form as much as possible before sending it.
          </Text>
          <Text fontWeight="bold">
            Please allow {REVIEW_BUSINESS_DAYS} business days for the request to be processed.
          </Text>
          <ContactInfoAlert />
        </Stack>
      )}
      rightFooterContent={() => (
        <Button variant="outline" onClick={onClose}>
          Close
        </Button>
      )}
    />
  )
}
